import axiosInstance from "./AxiosInstance"

const API_URL = "/attendances"
const ATTENDANCES_PAGE_CAP = 100
const ATTENDANCES_DEFAULT_LIMIT = 10

export const listAttendances = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}`, {
      params: { ...params },
    })
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    }
  } catch (error) {
    console.error("Error fetching attendances", error)
    throw error
  }
}

// 🔹 Get all attendances with pagination & search
export const getattendances = async (limit = 10, page = 1, search = "", includeTotal = true) => {
  try {
    const safeLimit = Math.max(1, Math.min(ATTENDANCES_PAGE_CAP, Number.parseInt(limit, 10) || ATTENDANCES_DEFAULT_LIMIT))
    const safePage = Math.max(1, Number.parseInt(page, 10) || 1)
    const safeSearch = search || ""
    const response = await axiosInstance.get(
      `${API_URL}?limit=${safeLimit}&page=${safePage}&search=${safeSearch}&includeTotal=${includeTotal ? "true" : "false"}`
    )
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    }
  } catch (error) {
    console.error("Error fetching attendances", error)
    throw error
  }
}

// 🔹 Create a new attendance
export const createattendance = async (attendanceData) => {
  try {
    const response = await axiosInstance.post(API_URL, attendanceData)
    return response.data
  } catch (error) {
    console.error("Error creating attendance", {
      error: error.response?.data,
      requestData: attendanceData,
    })
    throw error
  }
}

// 🔹 Update an attendance
export const updateattendance = async (attendanceId, attendanceData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/${attendanceId}`, attendanceData)
    return response.data
  } catch (error) {
    console.error("Error updating attendance", error)
    throw error
  }
}

// 🔹 Delete an attendance
export const deleteattendance = async (attendanceId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${attendanceId}`)
    return response.data
  } catch (error) {
    console.error("Error deleting attendance", error)
    throw error
  }
}

// 🔹 Get attendance by ID
export const getattendanceById = async (attendanceId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${attendanceId}`)
    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message,
    }
  } catch (error) {
    console.error("Error fetching attendance details", error)
    throw error
  }
}

// 🔹 Get attendances by batch ID
export const getattendancesByBatch = async (batchId, filters = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}`, {
      params: { ...filters, batchId },
    })
    return {
      data: response.data.data,
      status: response.status,
      message: response.data.message,
    }
  } catch (error) {
    console.error("Error fetching batch attendances", error)
    throw error
  }
}

export const getAttendanceSummary = async ({ batchId, studentId, startDate, endDate } = {}) => {
  if (!batchId || !studentId) return { data: null }
  const response = await axiosInstance.get(`${API_URL}/summary`, {
    params: { batchId, studentId, startDate, endDate },
  })
  return response.data
}

/* The Attendance Report page. Every figure is worked out by the API over
   all matching sessions (lms-api attendances/attendance.report.js); the
   page only prints what comes back. */

// Complete course / batch / trainer lists for the report's filters.
export const getAttendanceReportOptions = async () => {
  const response = await axiosInstance.get(`${API_URL}/report/options`)
  return response.data?.data || { courses: [], batches: [], trainers: [] }
}

// { courseId, batchId, trainerId, from, to } -> the whole report.
export const getAttendanceReport = async (params = {}) => {
  const response = await axiosInstance.get(`${API_URL}/report`, { params, timeout: 60000 })
  return response.data?.data || null
}

// One batch's per-day attendance for the report's batch popup.
export const getAttendanceReportBatch = async (batchId, params = {}) => {
  const response = await axiosInstance.get(`${API_URL}/report/batch/${batchId}`, { params })
  return response.data?.data || null
}
